import {
  IonButton,
  IonButtons,
  IonContent,
  IonDatetime,
  IonDatetimeButton,
  IonGrid,
  IonHeader,
  IonItem,
  IonList,
  IonLoading,
  IonMenuButton,
  IonModal,
  IonPage,
  IonSearchbar,
  IonText,
  IonTitle,
  IonToast,
  IonToolbar,
  useIonViewWillEnter,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
// import "../../components/ExploreContainer.css";
import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  styled,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import axios from "axios";
import { requestID, baseUrl, config } from "../../common/utils";

import NativeSelect from "@mui/material/NativeSelect";
import InputBase from "@mui/material/InputBase";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useBusinessContext } from "../../context/business-context";
import { MenuButton } from "../../components/Menu";

const LedgerReport = () => {
  const schema = yup
    .object({
      squery: yup.string().required("Please select a ledger"),
    })
    .required();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const { name } = useParams<{ name: string }>();
  const { selectedBusiness} = useBusinessContext()

  const [ledgetType, setLedgetType] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [ledgerMother, setLedgerMother] = useState([]);

  const [isOpen, setIsOpen] = useState(false);
  const [status, setStatus] = useState({ loading: false, error: false });
  const [errorLogin, setErrorLogin] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [ratingRange, setRatingRange] = useState("0");
  const [message, setMessage] = useState("");
  const [showme, setShowme] = useState(true);
  const [ledgerName, setLedgerName] = useState("");
  const [ledgerEntry, setLedgerEntry] = useState([]);
  const [checkTeller, setcheckTeller] = useState<Boolean>(false);

  const [transMode, setTransMode] = useState("");
  const [post_sn, setPOst_sn] = useState("");
  const [transType, setTransType] = useState("");
  const [ledgerNo, setLedgerNo] = useState("");
  const [reference, setReference] = useState("");
  const [referenceDetail, setreferenceDetail] = useState("");
  const [amount, setAmount] = useState("");

  const [inputValue, setInputValue] = React.useState("");
  const [tellerFormData, SetTellerFormData] = useState([]);

  const [query, setQuery] = useState("");
  const [desp, setDesp] = useState("");
  const [squery, SetSquery] = useState("");

  var today = new Date();
  var year = today.getFullYear();
  var month = String(today.getMonth() + 1).padStart(2, "0"); // January is 0, so we add 1
  var day = String(today.getDate()).padStart(2, "0");
  var formattedDate = `${year}-${month}-${day}`;

  const [posting, setPosting] = useState([]);
  const [orderDetails, setOrderDetails] = useState(null);
  // const [status, setStatus] = useState({ loading: false, error: false });
  const [error, setError] = useState("");
  const [startDate, setStartDate] = useState(formattedDate);
  const [endDate, setEndDate] = useState(formattedDate);
  const [allLedger, setAllLedger] = useState([]);

  const checkTellerx = () => {
    checkTeller ? setcheckTeller(false) : setcheckTeller(true);

    console.log(checkTeller);
  };

  const history = useHistory();
  const callToast = () => {
    setShowToast(true);
    setTimeout(() => setShowToast(false), 5000);
  };

  const getLedgers = () => {
    
    const formData = new FormData();
    formData.append("requestID", requestID());
    formData.append("business_id", selectedBusiness.business_id);
       formData.append("branch_id", selectedBusiness.branch_id);
    setStatus({ loading: true, error: false });
    axios
      .post(baseUrl() + "ledgercreates/getAllLedger_caas_branch", formData, config)
      .then((response) => {
        console.log(response);
        console.log(response.data.data);

        setAllLedger(response.data.data);

        setStatus({ loading: false, error: false });
      })
      .catch((error) => {
        setStatus({ loading: false, error: false });
        // throw new error("hey ");
      });
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  const filteredShops = allLedger?.filter((allLedger) =>
    allLedger?.name.toLowerCase().includes(query.toLowerCase())
  );

  const queryEmpty = () => {
    SetSquery("");
  };
  const queryKeep = (name, sn) => {
    setPOst_sn(sn);
    console.log(name, sn);
    SetSquery(name);
    setQuery("");
  };

  const BootstrapInput = styled(InputBase)(({ theme }) => ({
    "label + &": {
      marginTop: theme.spacing(3),
    },
    "& .MuiInputBase-input": {
      borderRadius: 4,
      position: "relative",
      backgroundColor: theme.palette.background.paper,
      border: "1px solid #ced4da",
      fontSize: 16,
      padding: "10px 26px 10px 12px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
      "&:focus": {
        borderRadius: 4,
        borderColor: "#80bdff",
        boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
      },
    },
  }));

  const [age, setAge] = React.useState("");
  const handleChange = (event: { target: { value: string } }) => {
    setAge(event.target.value);
  };
  //const history = useHistory();

  useIonViewWillEnter(() => {
    // getLedgers();
    // getTellerFormData();
    getLedgers();
    //getMyPostingReport();
  });
    useEffect(() => {
      getLedgers();
    }, []);

  const getPostingReport = async () => {
    setStatus({ loading: true, error: false });
    try {
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("startDate", startDate);
      formData.append("endDate", endDate);
      formData.append("sn", post_sn);
      const response = await axios.post(
        baseUrl() + "ledgers/getPostingReport",
        formData,
        config
      );
      console.log(response);
      const data = response.data.data;
      // setLedgerEntry(data);
      console.log(data);
      setPosting(data);
      setPOst_sn('')
      setStatus({ loading: false, error: false });
      //setSegment("attending");
    } catch (error) {
      setStatus({ loading: false, error: true });
    }
  };
  const formatNumber = (value) => {
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  };
  let runningBalance = 0; // Initialize running balance

  return (
    <IonPage className="pushDown">
          <MenuButton /> {/* This adds the hamburger icon */}
      
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>{name}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">{name} </IonTitle>
          </IonToolbar>
        </IonHeader>

        <Box
          sx={{
            paddingTop: "20px",
            display: "flex",

            "& > :not(style)": { m: 1 },
          }}
        >
          <h5> Generate Posting Reports </h5>

          <Divider orientation="horizontal" flexItem />
        </Box>

        <Divider orientation="horizontal" flexItem />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            paddingRight: "20px",
            paddingLeft: "20px",
            "& > :not(style)": { m: 1 },
          }}
        >
          <FormControl fullWidth>
            {/* <IonSearchbar
              className="searchBar"
              placeholder="Search Ledger"
              value={squery}
              onClick={queryEmpty}
              mode="ios"
              animated={true}
              onIonInput={(event) => {
                setQuery(event.detail.value), SetSquery(event.detail.value);
              }}

              
            ></IonSearchbar> */}

            <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              label="Search Ledger "
              error={!!errors.squery}
              {...register("squery")}
              helperText={errors.squery?.message}
              value={squery}
              onClick={queryEmpty}
              // onCha={(event) => {
              //   setQuery(event.detail.value), setTransType(event.detail.value);
              // }}
              onChange={(event) => {
                setQuery(event.target.value), SetSquery(event.target.value);
              }}
              required
            />

            {query != "" && (
              <IonList className="buyer_searchCan">
                {filteredShops?.map((result, i) => {
                  return (
                    <IonItem
                      key={i}
                      lines="none"
                      className="buyer_searchShop"
                      onClick={(event) => {
                        queryKeep(result?.name, result?.sn);
                      }}
                      //routerLink={`/my/buyerShopView/${result?.sn}`}
                    >
                      {result?.name}
                    </IonItem>
                  );
                })}
              </IonList>
            )}
            {/* <IonList> */}
            {query != "" && filteredShops?.length < 1 && (
              <IonItem lines="none"> No searched ledger found</IonItem>
            )}
          </FormControl>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            width: "80%",
            paddingLeft: "20px",
            marginTop: "0%",
            marginLeft: "20%",
            "& > :not(style)": { m: 1 },
          }}
        >
          {/* <IonItem>
              <IonLabel>Select start Date</IonLabel>
  
              <IonDatetimeButton datetime="datetime"></IonDatetimeButton>
              <IonModal keepContentsMounted={true}>
                <IonDatetime
                  id="datetime"
                  value={startDate}
                  min="2024-01-01"
                  presentation="date"
                  max="2099-12-31"
                  showDefaultButtons={true}
                  onIonChange={(e) => setStartDate(e.detail.value!)}
                >
                  Select End Date
                </IonDatetime>
              </IonModal>
            </IonItem> */}

          <IonText> Start</IonText>
          <IonDatetimeButton datetime="datetime"></IonDatetimeButton>
          <IonModal keepContentsMounted={true}>
            <IonDatetime
              id="datetime"
              value={startDate}
              min="2024-01-01"
              color={"warning"}
              presentation="date"
              max="2099-12-31"
              showDefaultButtons={true}
              onIonChange={(e) => {
                setStartDate(e.detail.value!), getPostingReport();
              }}
            >
              Start
            </IonDatetime>
          </IonModal>

          {/*  */}

          <IonText slot=""> End </IonText>
          <IonDatetimeButton
            color={"warning"}
            datetime="datetime2"
          ></IonDatetimeButton>
          <IonModal keepContentsMounted={true}>
            <IonDatetime
              id="datetime2"
              value={endDate}
              presentation="date"
              min="2024-01-01"
              color={"warning"}
              max="2099-12-31"
              showDefaultButtons={true}
              onIonChange={(e) => {
                {
                  setEndDate(e.detail.value!), getPostingReport();
                }
              }}
            >
              {/* Select End Date */}
            </IonDatetime>
          </IonModal>

          <IonButton
            onClick={handleSubmit(getPostingReport)}
            mode="md"
            size="small"
            color="secondary"
          >
            Generate Report{" "}
          </IonButton>
        </Box>

        <Divider orientation="horizontal" flexItem />

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",

            marginTop: "1%",
            // marginLeft:'40%',
            "& > :not(style)": { m: 1 },
          }}
        >
          <Table sx={{ minWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell align="left">S/N</StyledTableCell>
                <StyledTableCell align="left">Posting Date</StyledTableCell>
                <StyledTableCell align="left">Transaction Date</StyledTableCell>
                <StyledTableCell align="left">Description </StyledTableCell>
                <StyledTableCell align="left">Dr. </StyledTableCell>
                <StyledTableCell align="left">Cr. </StyledTableCell>
                <StyledTableCell align="left">Balance </StyledTableCell>
              </TableRow>
            </TableHead>
            {posting?.map((posting, i) => {
              // Calculate the running balance
              runningBalance += (posting.dr || 0) - (posting.cr || 0); // Add debit and subtract credit

              return (
                <StyledTableRow key={i}>
                  <StyledTableCell align="left">{i + 1}</StyledTableCell>
                  <StyledTableCell align="left">
                    {posting.postDate}
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    {posting.finDate}
                  </StyledTableCell>
                  <StyledTableCell align="left">{posting.desp}</StyledTableCell>
                  <StyledTableCell align="left">
                    {formatNumber(posting.dr)}
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    {formatNumber(posting.cr)}
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    {formatNumber(runningBalance)}
                  </StyledTableCell>{" "}
                  {/* Display running balance */}
                  {/* Display running balance */}
                </StyledTableRow>
              );
            })}
          </Table>
        </Box >
        {posting && posting.length <= 0 && (
          <Box  sx={{ m: 1, alignItems: "center" }}> <Typography align="center">No Report yet
            </Typography>  </Box>
        )}
        <IonLoading
          message="Please Wait..."
          spinner="circles"
          isOpen={status.loading}
        />
        {status.error && (
          <IonToast position="middle" isOpen={showToast} message={errorLogin} />
        )}
      </IonContent>
    </IonPage>
  );
};

export default LedgerReport;
